module.exports = "/_next/static/files/1eaa29d398504281faef145e1bb9b3ee.png";